import { render, staticRenderFns } from "./physical.vue?vue&type=template&id=7ebf0880&scoped=true"
import script from "./physical.vue?vue&type=script&lang=ts"
export * from "./physical.vue?vue&type=script&lang=ts"
import style0 from "./physical.vue?vue&type=style&index=0&id=7ebf0880&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ebf0880",
  null
  
)

export default component.exports